import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface PropertyGroupProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

export const PropertyGroup: React.FC<PropertyGroupProps> = ({
  title,
  children,
  defaultExpanded = true
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-gray-200 dark:bg-gray-700 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center gap-2 px-4 py-3 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
      >
        {isExpanded ? (
          <ChevronDown className="w-4 h-4 text-gray-700 dark:text-gray-300" />
        ) : (
          <ChevronRight className="w-4 h-4 text-gray-700 dark:text-gray-300" />
        )}
        <span className="text-gray-900 dark:text-white font-semibold text-sm">{title}</span>
      </button>
      
      {isExpanded && (
        <div className="px-4 pb-3 space-y-1">
          {children}
        </div>
      )}
    </div>
  );
};

